import { cartConstants } from "services/redux/cart/constants";
import store from "services/redux/store";

export default class ObjectCart {
	
	static log = ( value ) => {
		console.prefix( 'ObjectCart', value );
	}
	
	static getSelectedTimeslots = () => {
		const state = store.getState();
		
		return {
			...state.cart[ cartConstants.TIMESLOTS ]
		};
	}
}
